import { useMemo } from 'react';
import { CoordinationClient } from '@atlassiansox/engagekit-ts';
export var useCoordinationClient = function useCoordinationClient(cloudId, workspaceId, orgId) {
  return useMemo(function () {
    return new CoordinationClient({
      cloudId: cloudId,
      stargateUrl: '/gateway/api',
      workspaceId: workspaceId,
      orgId: orgId
    });
  }, [cloudId, workspaceId, orgId]);
};